import React, { useEffect, useState } from "react";
import cx from "../Portal.module.css";
import { Row, Col, Button } from "react-bootstrap";
import { httpPortal } from "../../Apis/commonApis";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setPortalRefreshToken,
  setPortalAccessTokenExpiry,
} from "../../redux-toolkit/reducer/portalRefreshToken_reducer";
import swal from "sweetalert";

export default function CheckSecurityQuestion() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location.state?.email;
  const security_questions = location.state?.security_questions;
  const [error, setError] = useState("");

  let checkSecurityQuestions = async (postdata) => {
    var data = JSON.stringify({
      email: email,
      question: security_questions,
      answer: postdata?.Answer,
    });
    const res = await httpPortal(
      "checkSecurityQuestions",
      "post",
      data,
      "withoutToken"
    );
    if (res.status && res.data && res.token && res.caresite) {
      handleRefreshToken(res);
    } else {
      setError(res?.message);
    }
  };

  const handleRefreshToken = (res) => {
    localStorage.setItem("fandfData", JSON.stringify(res.data));
    localStorage.setItem("fandfam_token", res.token);
    localStorage.setItem("careSite", JSON.stringify(res?.caresite));

    console.log("localStorage set for portal 11111111111");
    // Save refresh token to Redux store
    if (res.refreshToken) {
      dispatch(
        setPortalRefreshToken({
          refreshToken: res.refreshToken,
        })
      );
    }

    // Update access token expiry in Redux
    dispatch(
      setPortalAccessTokenExpiry({
        accessToken: res.token,
      })
    );

    swal("Success", res.message, "success").then((value) => {
      history.push(`/portal/portal-main`, { replace: true });
    });
  };

  return (
    <div className={`${cx.LoginStart}`}>
      <div className={`container`}>
        <Row>
          <Col lg={4} md={6} sm={12} className={`m-auto`}>
            <div className={`${cx.LoginBox}`}>
              <img src="/admin/images/Newfooter_Logo.svg" alt="" />
              <h3>Welcome,</h3>
              <p>Please enter security answer. </p>
              <h3 className="mt-4">Question</h3>
              <p>{security_questions}</p>
              <div className={`${cx.formInput}`}>
                <div className={`${cx.inputEmail}`}>
                  <label>Answer</label>
                  <input
                    className={`form-control`}
                    type="text"
                    placeholder="Answer"
                    {...register("Answer", {
                      required: true,
                    })}
                  />
                </div>
                {errors?.Answer?.type === "required" && (
                  <p className="errorMessage">This field is required</p>
                )}
                <p>{error}</p>
              </div>
              <div className={`${cx.continueButton}`}>
                <NavLink to="#" onClick={handleSubmit(checkSecurityQuestions)}>
                  Continue
                </NavLink>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
